import { makeAutoObservable } from 'mobx';
import { DayCountConventionEnum, SavingsAccountHistoryMetaDataDto } from '../../../../defs/api';

export class SavingsAccountHistoryMetaDataMobxDto implements SavingsAccountHistoryMetaDataDto {
    dayCountConvention: DayCountConventionEnum | null;

    interestRate: number;

    taxRate?: number;

    interestBeforeTax?: number;

    interest?: number;

    tax?: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: SavingsAccountHistoryMetaDataDto): SavingsAccountHistoryMetaDataMobxDto {
        const mobxDto = new SavingsAccountHistoryMetaDataMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: SavingsAccountHistoryMetaDataDto[]): SavingsAccountHistoryMetaDataMobxDto[] {
        const createdDtos: SavingsAccountHistoryMetaDataMobxDto[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(SavingsAccountHistoryMetaDataMobxDto.create(dto));
        });

        return createdDtos;
    }
}
